import styled from 'styled-components';
// styled-components.
// -----------------------------------------------------------------------------
export const TableBodyRoot = styled.tbody ``;
//# sourceMappingURL=TableBody.styled.js.map